<!--20211102 sea bert-->
<template>
  <div>
    <div class="container_right">
      <div class="container_right_hotrecommend">
        <div class="container_right_hotrecommend_icon">热门推荐</div>
<!--        <div class="container_right_hotrecommend_img">-->
<!--          <div v-for="(item, index) in recommendpics" :key="index" class="container_right_hotrecommend_img">-->
<!--            <img :src=item.pics[0].url alt="">-->
<!--          </div>-->
<!--        </div>-->
        <div class="container_right_hotrecommend_font">
          <div v-for="(item, index) in list" :key="index" class="container_right_hotrecommend_font">
            <li v-rblink="{name: 'CmsDetail', query: {id: item.id}}">{{ item.title }}</li>
          </div>
        </div>
      </div>
      <div class="container_right_doublecode" v-if="false">
        <div class="container_right_doublecode_img"></div>
        <div class="container_right_doublecode_font">
          <div class="container_right_doublecode_font_up">更多精彩内容</div>
          <div class="container_right_doublecode_font_down">
            请关注CCA官方公众号
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "RightNav",
  props: {
    list: {
      type: Array,
      default: []
    },
  },
  data() {
    return {
      // list: []
    };
  },
  computed: {
    // tabListNew() {
    //   return {
    //     "--length": this.tabList.length
    //   };
    // }
  },
  mounted() {
    // this.geRecommendlist()
  },
  methods: {

  },
};
</script>
<style lang="scss" scoped>
.container_right {
  width: 306px;

  .container_right_search {
    width: 100%;
    height: 44px;

    /deep/ .el-input__inner {
      height: 44px;

      border-radius: 22px;
    }
  }

  .container_right_hotrecommend {
    width: 306px;
    //height: 450px;
    background: #fff4ed;
    border-radius: 17px;
    // margin-top: 11px;
    box-sizing: border-box;
    padding: 20px 12px;

    .container_right_hotrecommend_icon {
      width: 125px;
      height: 55px;
      line-height: 55px;
      background: url("~@/assets/images/mainindex/icon-news-list-recommend@2x.png") no-repeat;
      background-size: 100% 100%;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      padding-left: 30px;
      box-sizing: border-box;
    }

    .container_right_hotrecommend_img {
      width: 282px;
      height: 121px;
      // background: url("~@/assets/images/mainindex/pic-news-recommend@2x.png")
      //   no-repeat center center;
      // background-size: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }

    .container_right_hotrecommend_font {
      width: 267px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 17px;
      margin-top: 23px;

      li {
        list-style: disc;
        margin-left: 14px;
        margin-top: 15px;
        cursor: pointer;

        &::marker {
          color: #87c5f5;
        }

        &:hover {
          font-weight: bolder;
          //cursor: pointer;
        }
      }
    }
  }

  .container_right_doublecode {
    width: 302px;
    height: 116px;
    background: #f8f8f8;
    border-radius: 20px;
    margin-top: 48px;
    padding: 19px 0 19px 11px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;

    .container_right_doublecode_img {
      width: 78px;
      height: 78px;
      background: url("../../assets/images/contact/cca-2.png") no-repeat center center;
      background-size: 100% 100%;
    }

    .container_right_doublecode_font {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-top: 5px;
      margin-left: 8px;
      box-sizing: border-box;

      .container_right_doublecode_font_down {
        font-weight: bolder;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// RightNav.vue?1a15ae62